var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDiary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,16h2v7l-1,1H3L2,23V20H2V19H1V17H2V13H1V11H2V7H1V5H2V1L3,0H21l1,1V6H20V2H4V5H5V7H4v4H5v2H4v4H5v2H4v1H4v2H20ZM17,5H7V7H17ZM14.35,18.77l6.57-6.57L18.8,10.08l-6.57,6.57-1.08,2.5.7.7ZM22.29,8H20.88l-.71.71,2.12,2.12.71-.71V8.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiary);
export default __webpack_public_path__ + "static/1782902422/media/icon-diary.af15ffd78b30e642d696dcba14e04df2.svg";
export { ForwardRef as ReactComponent };